exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".new-group{cursor:pointer}.card_text{min-height:80px;margin-bottom:10px}a{text-decoration:none}.invisible{display:none}.alert{margin-left:30px}.error{background-color:unset!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/groupsView.vue"],"names":[],"mappings":"AACA,WACI,cAAe,CAClB,AACD,WACI,gBAAiB,AACjB,kBAAoB,CACvB,AACD,EACG,oBAAqB,CACvB,AACD,WACI,YAAa,CAChB,AACD,OACI,gBAAkB,CACrB,AACD,OACI,gCAAmC,CACtC","file":"groupsView.vue","sourcesContent":["\n.new-group{\n    cursor:pointer;\n}\n.card_text{\n    min-height: 80px;\n    margin-bottom: 10px;\n}\na{\n\t  text-decoration:none;\n}\n.invisible {\n    display:none;\n}\n.alert {\n    margin-left: 30px;\n}\n.error {\n    background-color: unset !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-385be56e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/groupsView.vue
// module id = 1372
// module chunks = 30